export default "__VITE_ASSET__jo_C9Zx3__"